import { render, staticRenderFns } from "./BonsCommandeApproView.vue?vue&type=template&id=00444967"
import script from "./BonsCommandeApproView.vue?vue&type=script&lang=js"
export * from "./BonsCommandeApproView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports